
import React, { useState, useRef } from "react";
import { useCalendar } from "./CalenderContext";
import { AddEventModal, UpdateEventModal, AllEventMiniModal, AllEventDetailModal } from "./AddEventModal";


const DayView = () => {
  const {
    currentMonth,
    handleDayClick,
    selectedDate,
    daysOfWeek,
    todayDate,
    todayMonth,
    todayYear,
    handleClickOnEventName,
    withStopPropagation,
    showModal,
    setShowModal,
    showModalupdate,
    setShowModalupdate,
    selectedTimeSlot,
    timeSlots,
    isShowAllEventDatemini,
    setShowAllEventDatemini,
    handleShowAllEvent,
    selectedEventmini,
    handleShowAllEventDetail,
    setShowModaldetail,
    showModaldetail,
    handleShowAllUpdate,
    selectedEventupdate,
    SelectedEventDetail,
    formatDate,
    setselectedTimeSlot,
    meetingData,
    getMeetingData,
    Handlecloseallmodal
  } = useCalendar();

  const [dayPosition, setDayPosition] = useState(null);
  const [selectedEvent, setSelectedEvent] = useState(null); // Track the selected event





  // Handle time slot click
  const handleTimeSlotClickWithPosition = (hour, minute, event) => {
    event.stopPropagation();


    const startTime = `${String(hour).padStart(2, "0")}`;

    // Set the end time one hour later
    const endHour = (hour + 1) % 24; // Handle 24-hour wrap around
    const endTime = `${String(endHour).padStart(2, "0")}`;

    // Get AM/PM format for display purposes
    const startPeriod = hour < 12 ? 'AM' : 'PM';
    const endPeriod = endHour < 12 ? 'AM' : 'PM';
    // const startHour12 = hour % 12 || 12; // Convert to 12-hour format
    // const endHour12 = endHour % 12 || 12; // Convert to 12-hour format

    // Create a combined selected time slot object
    const timeSlotData = {

      start: `${startTime}:00`,
      end: `${endTime}:00`,

    };

    setselectedTimeSlot(timeSlotData)


    const rect = event.currentTarget.getBoundingClientRect();
    const position = {
      x: rect.left,
      y: rect.top,
    };

    setDayPosition(position);
    setShowModal(true);
  };

  // Filter events for the selected date


  const handleEventClick = (e, events, day) => {
    // Set the flag to indicate this click originated from an event
    eventClickRef.current = true;

    // Call stopPropagation as a first line of defense
    e.stopPropagation();
    e.preventDefault();


    handleShowAllEventDetail(e, events, day);
  };
  const eventClickRef = useRef(false);
  const handleMoreClick = (e, events, day) => {
    // Set the flag to indicate this click originated from an event
    eventClickRef.current = true;
    console.log(events, "clciked")
    // Call stopPropagation as a first line of defense
    e.stopPropagation();
    e.preventDefault();

    // Process the "more" click
    handleShowAllEvent(e, events, day);
  };

  // Handle opening the Mini Modal for "See More"


  // Handle opening the Update Event Modal


  // Render events for a specific time slot
  const renderEvents = (hour, minute, day) => {
    const maxEventsToShow = 1; // Maximum number of events to show initially
    const eventsAtTime = meetingData.length > 0 && meetingData?.filter((event) => {
      const eventStartTime = new Date(`${event.meeting_date}T${event.start_time}`); // Combine date and time
      const eventHour = eventStartTime.getHours();
      const eventMinute = eventStartTime.getMinutes();
      const eventdate = eventStartTime.getDay()
      // Match by hour and minute (if minute is provided)
      if (minute !== undefined) {
        return eventHour === hour && eventMinute === minute;
      }
      return eventHour === hour && eventdate === selectedDate.getDay(); // Match by hour only
    });

    const more = eventsAtTime.length - maxEventsToShow;

    return (
      <>

        {eventsAtTime.length > 0 && eventsAtTime.slice(0, maxEventsToShow).map((event, index) => (
          <div key={index} onClick={(e) => {

            e.stopPropagation();
            e.preventDefault();
          }}>
            <div
              className="event-name"
              onClick={(e) => handleEventClick(e, event, day)}
              onMouseDown={(e) => {
                // Set flag on mousedown too
                eventClickRef.current = true;
                e.stopPropagation();
              }}

            >
              {event.title || "Untitled"}
              <AllEventDetailModal
                showModal={showModaldetail}
                onClose={() => setShowModaldetail(false)}
                selectedEvent={[event]}
                dayPosition={dayPosition}
                showModalupdate={showModalupdate}
                setShowModalupdate={setShowModalupdate}
                handleShowAllUpdate={handleShowAllUpdate}
                timeSlots={timeSlots}
                selectedTimeslot={selectedTimeSlot}
                selectedDate={selectedDate}
                setShowModaldetail={setShowModaldetail}
              />
            </div>
          </div>
        ))}


        {more > 0 && (
          <div className="relative" onClick={(e) => {

            e.stopPropagation();
            e.preventDefault();
          }}>
            <div
              onClick={(e) => handleMoreClick(e, eventsAtTime, day)}
              onMouseDown={(e) => {
                // Set flag on mousedown too
                eventClickRef.current = true;
                e.stopPropagation();
              }}
              className="event-name see-more-btn w-max"
            >
              {more} more...
              <AllEventMiniModal
                showModal={isShowAllEventDatemini}
                onClose={() => {
                  setShowAllEventDatemini(false);
                  setShowModal(false);
                }}
                dayPosition={dayPosition}
                selectedEventmini={selectedEventmini}
                showModaldetail={showModaldetail}
                timeSlots={timeSlots}
                selectedTimeslot={selectedTimeSlot}
                setShowModaldetail={setShowModaldetail}
                handleShowAllEventDetail={handleShowAllEventDetail}
                handleShowAllUpdate={handleShowAllUpdate}
                selectedDate={selectedDate}
              />
            </div>
          </div>
        )}
      </>
    );
  };

  return (
    <div className="day-view">
      {/* Header Section */}
      <div className="day-header">
        <h2>{formatDate(selectedDate)}</h2>
      </div>

      {/* Time Slots */}
      <div className="time-slots">
        {Array.from({ length: 24 }, (_, hour) => ({
          hour,
          minute: 0, // Set minutes to 0 for one-hour intervals
        })).map((slot, index) => {
          const { hour, minute } = slot; // Extract hour and minute from the object
          const hour12 = hour % 12 || 12; // Convert to 12-hour format
          const ampm = hour < 12 ? "AM" : "PM"; // Determine AM/PM
          const timeString = `${String(hour12).padStart(2, "0")}:${String(minute).padStart(2, "0")} ${ampm}`;

          return (
            <div
              key={index}
              className="time-slot"
              onClick={(event) => handleTimeSlotClickWithPosition(hour, minute, event)}
            >
              {/* Time Label */}
              <span className="time-label">{timeString}</span>

              {/* Events for This Time Slot */}
              <div className="events">{renderEvents(hour, minute, selectedDate)}</div>
            </div>
          );
        })}
      </div>

      {/* Modals */}
      <AddEventModal
        showModal={showModal}
        onClose={() => setShowModal(false)}
        dayPosition={dayPosition}
        timeSlots={timeSlots}
        selectedTimeslot={selectedTimeSlot}
        selectedDate={selectedDate}
        getMeetingData={getMeetingData}
        Handlecloseallmodal={Handlecloseallmodal}
      />

      <UpdateEventModal
        showModal={showModalupdate}
        onClose={() => setShowModalupdate(false)}
        dayPosition={dayPosition}
        timeSlots={timeSlots}
        selectedTimeslot={selectedTimeSlot}
        selectedEvent={selectedEventupdate}
        getMeetingData={getMeetingData}
        Handlecloseallmodal={Handlecloseallmodal}
      />


    </div>
  );
};

export default DayView;
